module.exports = __webpack_public_path__ + "static/media/call_to_action_bg.820dbd20.svg";